import { useEffect, useState } from 'react';
import { Honeybadger } from '@honeybadger-io/react';

export const useHoneybadger = () => {
  const [honeybadger, setHoneybadger] = useState(false);

  const hbConfig = {
    apiKey: process.env.HONEYBADGER_API_KEY,
    environment: process.env.NEXT_PUBLIC_HONEYBADGER_ENV || process.env.NODE_ENV
  };

  useEffect(() => {
    if (process.env.NODE_ENV !== 'development') {
      setHoneybadger(Honeybadger?.configure(hbConfig));
    }
  }, []);

  const notifyHB = (error, options = {}) => {
    honeybadger?.notify?.(error, options);
  };

  const setContext = (contextObject) => {
    honeybadger?.setContext?.(contextObject);
  };

  return {
    notifyHoneybadger: notifyHB,
    setHoneybadgerContext: setContext
  };
};

export default useHoneybadger;
